import styled from 'styled-components'

export const Button = styled.button`
  align-items: center;
  background-color: ${({ theme, bgColor }) =>
    theme.colors[bgColor] || bgColor || theme.colors.primary};
  border: 0;
  box-shadow: none;
  color: ${({ theme, textColor }) =>
    theme.colors[textColor] || textColor || theme.colors.white};
  display: flex;
  font-size: ${({ theme }) => theme.fontSizes[14]}px;
  font-weight: ${({ theme }) => theme.fontWeight[4]};
  justify-content: center;
  max-width: 250px;
  min-height: 50px;
  outline: none;
  text-align: center;
  text-decoration: none;
  text-decoration-thickness: 2px;
  text-underline-offset: 6px;
  transition: all 0.2s ease-out 0s;
  width: 100%;

  &:hover {
    background-color: ${({ theme, bgHover }) =>
      theme.colors[bgHover] || bgHover || theme.colors.primary};
    color: ${({ theme, textHover }) =>
      theme.colors[textHover] || textHover || theme.colors.white};
    cursor: pointer;
    text-decoration-line: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 6px;
  }

  ${({ theme }) => theme.below.mobileL`
    font-size: ${theme.fontSizes[2]}px;
    min-width: 100%;
  `}
`
